import { joinFiltersSelectedValues } from '@/helpers/QueryString.js';

/**
 * @typedef {import('@/types').EngineSnapshot} EngineSnapshot
 */

/**
 * @param {EngineSnapshot} snapshot
 * @returns {string | boolean | number}
 */
function selectedTermValue(snapshot) {
	let index = snapshot.selected.term.indexOf(true);
	return snapshot.options.term[index].value;
}

/**
 * @param {EngineSnapshot} snapshot
 * @returns {0 | 1}
 */
function selectedEnrollableValue(snapshot) {
	let index = snapshot.selected.enrollable.indexOf(true);
	return snapshot.options.enrollable[index].value ? 1 : 0;
}

/**
 * @param {EngineSnapshot} snapshot
 * @returns {Record<string, string | number | boolean>}
 */
export function buildCollegeOptionsParams(snapshot) {
	return {
		college: joinFiltersSelectedValues(snapshot.options.college, snapshot.selected.college),
	};
}

/**
 * @param {EngineSnapshot} snapshot
 * @returns {Record<string, string | number | boolean>}
 */
export function buildTermOptionsParams(snapshot) {
	return {
		college: joinFiltersSelectedValues(snapshot.options.college, snapshot.selected.college),
		term: selectedTermValue(snapshot),
	};
}

/**
 * @param {EngineSnapshot} snapshot
 * @returns {Record<string, string | number | boolean>}
 */
export function buildCourseParams(snapshot) {
	return {
		college: joinFiltersSelectedValues(snapshot.options.college, snapshot.selected.college),
		term: selectedTermValue(snapshot),
		enrollable: selectedEnrollableValue(snapshot),
		subject: joinFiltersSelectedValues(snapshot.options.subject, snapshot.selected.subject),
	};
}

/**
 * @param {EngineSnapshot} snapshot
 * @param {Partial<{
 *   college: string,
 *   term: string | number | boolean,
 *   startsOn: string,
 *   campus: string,
 *   enrollable: number,
 *   format: string,
 *   days: string,
 *   subject: string,
 *   course: string,
 *   page: number,
 * }>} [overrides]
 * @returns {Record<string, string | number | boolean>}
 */
export function buildSearchParams(snapshot, overrides = {}) {
	return {
		college: overrides.college ?? joinFiltersSelectedValues(snapshot.options.college, snapshot.selected.college),
		term: overrides.term ?? selectedTermValue(snapshot),
		starts_on: overrides.startsOn ?? joinFiltersSelectedValues(snapshot.options.startsOn, snapshot.selected.startsOn),
		campus: overrides.campus ?? joinFiltersSelectedValues(snapshot.options.campus, snapshot.selected.campus),
		enrollable: overrides.enrollable ?? selectedEnrollableValue(snapshot),
		format: overrides.format ?? joinFiltersSelectedValues(snapshot.options.format, snapshot.selected.format),
		days: overrides.days ?? joinFiltersSelectedValues(snapshot.options.days, snapshot.selected.days),
		subject: overrides.subject ?? joinFiltersSelectedValues(snapshot.options.subject, snapshot.selected.subject),
		course: overrides.course ?? joinFiltersSelectedValues(snapshot.options.course, snapshot.selected.course),
		page: overrides.page ?? snapshot.results.current_page ?? 1,
	};
}
